import { Relatie } from '@/lib/types';
import { Form } from 'antd';
import { useMemo } from 'react';

export const useHeeftLozing = (teeltwijze: number): boolean => {
  const form = Form.useFormInstance<Relatie>();
  const lozingsVorm = Form.useWatch('lozingsVorm', form) || [];

  return useMemo(
    () => lozingsVorm.some(item => item?.betrekkingTotTeeltwijze === teeltwijze && [1, 2, 3].includes(item.value)),
    [lozingsVorm, teeltwijze]
  );
};
